import { Link } from "react-router-dom";
import { SITE } from "../lib/site";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-vyom-bg border-t border-vyom-rule"
        >
            <div className="container-vyom py-20 md:py-28">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
                    <div className="md:col-span-5">
                        <div className="font-serif-display text-3xl md:text-4xl leading-tight max-w-md">
                            Linen, refined for the houses that endure.
                        </div>
                        <div className="mt-8 text-[14px] text-vyom-mute max-w-sm leading-relaxed">
                            From the house of United Bleachers — seventy-five
                            years of textile craft, delivered to leading
                            brands across the world.
                        </div>
                    </div>

                    <div className="md:col-span-3 md:col-start-7">
                        <div className="text-[14px] uppercase tracking-overline text-vyom-mute mb-6">
                            Navigate
                        </div>
                        <ul className="space-y-3">
                            {SITE.nav.map((n) => (
                                <li key={n.href}>
                                    <Link
                                        to={n.href}
                                        data-testid={`footer-link-${n.label.toLowerCase()}`}
                                        className="text-[14px] text-vyom-ink hover:text-vyom-mute transition-colors duration-500"
                                    >
                                        {n.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[14px] uppercase tracking-overline text-vyom-mute mb-6">
                            Contact
                        </div>
                        <ul className="space-y-3 text-[14px]">
                            <li className="text-vyom-ink">
                                Vyom Tex Linen LLP
                            </li>
                            <li className="text-vyom-mute leading-relaxed">
                                1/482F, Transport Nagar,
                                <br />
                                Near Maharaja Theme Park,
                                <br />
                                Neelambur, Coimbatore,
                                <br />
                                Tamil Nadu — 641014
                            </li>
                            <li>
                                <a
                                    href="tel:+918220055388"
                                    data-testid="footer-phone"
                                    className="text-vyom-ink hover:text-vyom-mute transition-colors duration-500"
                                >
                                    +91 82200 55388
                                </a>
                            </li>
                            <li className="text-vyom-mute">
                                Mon — Sat, 9:30 — 18:00 IST
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-vyom-rule flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div className="text-[14px] uppercase tracking-overline text-vyom-mute">
                        © {new Date().getFullYear()} Vyom Tex Linen ·
                        A United Bleachers initiative
                    </div>
                    <div className="text-[14px] uppercase tracking-overline text-vyom-mute">
                        Made in India · Trusted across the world
                    </div>
                </div>

                {/* SEO content for crawlers & screen readers — visually hidden */}
                <div className="sr-only">
                    <h2>Luxury linen manufacturer in India</h2>
                    <p>
                        Vyom Tex Linen is a luxury bed linen, blanket, bath
                        linen and hospitality textile manufacturer in India.
                        We are a trusted bedsheet manufacturer, duvet cover
                        manufacturer, pillow cover manufacturer, table linen
                        manufacturer, quilt manufacturer and bath towel
                        manufacturer based in Coimbatore, Tamil Nadu. Our
                        mill produces 100% cotton, 100% linen and considered
                        blends of viscose, polyester, tencel, modal and
                        bamboo for hotels, retail houses and
                        direct-to-consumer brands. White-label, OEM and
                        private-label programs welcome.
                    </p>
                </div>
            </div>
        </footer>
    );
}
